import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';
import AppLink from 'components/common/AppLink';

class StepHeader extends React.Component {

  isContent(val) {
    if(val === null || val === '' || val === undefined ){
      return false;
    } else {
      return true;
    }
  }

  setMaxSteps = () => {
    const { childrenNumber, isLogged } = this.props;
    if (childrenNumber === 0 && isLogged) {
      return 3
    } else if (childrenNumber > 0 && isLogged || childrenNumber === 0 && !isLogged) {
      return 4
    } else if (childrenNumber > 0 && !isLogged ) {
      return 5
    }
  }

  render() {
    const { link, linkTitle, step, maxSteps, locale,
      title, margin='40', booking } = this.props;
    return (
      <Fragment>
        <div className={'steps-header' + ' mb-' + `${margin}`}>
          <AppLink to={link} title={linkTitle} className="button button--text">
            <FontAwesomeIcon
              icon={['fas', 'angle-left']}
              size="lg"
            />
          </AppLink>
          <p className="steps-header__label">
            <T>content.common.step</T>{' '}
            {`${step}/${booking ? this.setMaxSteps() : maxSteps}`}
          </p>
        </div>

        { this.isContent(title) &&
          <div className="head">
            <h3>{title}</h3>
          </div>
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    childrenNumber: state.booking.childrenNumber,
    isLogged: state.app.isLogged
  }
}

export default connect(mapStateToProps)(StepHeader);
